import { render, staticRenderFns } from "./EmployeesList.vue?vue&type=template&id=fdc65e78&scoped=true&"
import script from "./EmployeesList.vue?vue&type=script&lang=ts&"
export * from "./EmployeesList.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesList.vue?vue&type=style&index=0&id=fdc65e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc65e78",
  null
  
)

export default component.exports